import { EventData, LogParams } from '../redux/actions/statistics';
import { store } from '../redux/store';
import { APP_CFG } from './appcfg';
import { postFormData } from './network';

/*
This file is only for teacher logged events
*/

export enum DashboardEventType {
  startDashboardForClass = 'start dashboard',
  changeReportCardType = 'change report card type',
  openStudentsGauge = 'open students gauge',
  openStudentExampleGauge = 'open student example gauge',
  closeStudentExample = 'close student example',
  openExampleError = 'open example error',
  closeExampleError = 'close example error',
  openExampleProblem = 'open example problem',
  closeExampleProblem = 'close example problem',
  openSkillDescription = 'open skill desc',
  openSkillComponentDescription = 'open skill component desc',
  openQuestionDescription = 'open question desc',
  carouselRight = 'carousel right',
  carouselLeft = 'carousel left',
  openStudentResult = 'open student result',
  closeStudentResult = 'close student result',
  changeSkill = 'change skill',
  sortStudentResultColumn = 'sort result'
}

export interface DashboardEvent {
  cid: string;
  sessionId: string;
  type: DashboardEventType;
  data?: EventData;
}

// Have some generic timer loop to empty all queue like structures

export async function logDashboardEvent({ type, data, time }: LogParams) {
  const {
    app: { currentClassroomToken: cid, telemetryEnabled },
    statistics: { sessionId }
  } = store.getState();

  // TODO: Dashboard logging events should be placed in a queue.
  // That way, events that are logged BEFORE we get the user's telemetry setting aren't sent
  // and prevent several messages from being sent at once.
  if (cid && telemetryEnabled) {
    const fluentdHref = APP_CFG.getServerHref('fluentd');
    const index = APP_CFG.getIndex('fluentd', 'teacher');
    
    const event: DashboardEvent = {
      cid,
      sessionId,
      type,
      data,
    };
    
    const url = `${fluentdHref}.${index}${(time ? `?time=${time}` : '')}`;
    //console.log(url + JSON.stringify(event));
    postFormData(url, event);
  }
}
